import React from "react";
import DrawerList from "../../component/DrawerList";
import { 
  AccountBox, 
  Category, 
  Dashboard, 
  LocalOffer, 
  Logout, 
  Class, 
  ViewCarousel, 
  Star,
  Storefront,
  Inventory,
  ShoppingBag,
  ReceiptLong // Added icon for Transactions
} from "@mui/icons-material";

const menu = [
  {
    name: "Dashboard",
    path: "/admin",
    icon: <Dashboard className="text-primary-color" />,
    activeIcon: <Dashboard className="text-white" />,
  },
  {
    name: "Orders",
    path: "/admin/orders",
    icon: <ShoppingBag className="text-primary-color" />,
    activeIcon: <ShoppingBag className="text-white" />,
  },
  {
    name: "Transactions",
    path: "/admin/transactions",
    icon: <ReceiptLong className="text-primary-color" />,
    activeIcon: <ReceiptLong className="text-white" />,
  },
  {
    name: "Products",
    path: "/admin/products",
    icon: <Inventory className="text-primary-color" />,
    activeIcon: <Inventory className="text-white" />,
  },
  {
    name: "Sellers",
    path: "/admin/sellers",
    icon: <Storefront className="text-primary-color" />,
    activeIcon: <Storefront className="text-white" />,
  },
  {
    name: "Add Category",
    path: "/admin/add-category",
    icon: <Class className="text-primary-color" />,
    activeIcon: <Class className="text-white" />,
  },
  {
    name: "Categories List",
    path: "/admin/categories",
    icon: <Category className="text-primary-color" />,
    activeIcon: <Category className="text-white" />,
  },
  {
    name: "Deals",
    path: "/admin/deals",
    icon: <LocalOffer className="text-primary-color" />,
    activeIcon: <LocalOffer className="text-white" />,
  },
  {
    name: "Ads & Slides",
    path: "/admin/banners",
    icon: <ViewCarousel className="text-primary-color" />,
    activeIcon: <ViewCarousel className="text-white" />,
  },
  {
    name: "Sponsored Products",
    path: "/admin/sponsored-products",
    icon: <Star className="text-primary-color" />,
    activeIcon: <Star className="text-white" />,
  },
];

const menu2 = [
  {
    name: "Account",
    path: "/admin/account",
    icon: <AccountBox className="text-primary-color" />,
    activeIcon: <AccountBox className="text-white" />,
  },
  {
    name: "Logout",
    path: "/",
    icon: <Logout className="text-primary-color" />,
    activeIcon: <Logout className="text-white" />,
  },
];

interface AdminDrawerListProps {
  toggleDrawer?: () => void;
}

const AdminDrawerList = ({ toggleDrawer }: AdminDrawerListProps) => {
  return (
    <DrawerList menu={menu} menu2={menu2} toggleDrawer={toggleDrawer} />
  );
};

export default AdminDrawerList;